import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import { setRedirectAfterAuth } from '../../../modules/auth/actions/creators'

import {
  displayProfileModal,
  setProfileModalPage,
  setNotificationCount,
  setEmailVerificationStatus,
  setAccountStatus,
  setTransportationMall,
} from '../../../modules/profile/actions/creators'

import { setDisplayAppModal } from '../../../modules/explore/actions/creators'

import { setTicketCount } from '../../../modules/watch/actions/creators'

import {
  waitRenderServer,
  renderServer,
} from '../../../modules/ssr/actions/creators'

import TransportationRoutes from '../components/TransportationRoutes/TransportationRoutes'

const mapStateToProps = reduxState => {
  const { auth, profile, watch } = reduxState

  const { accessToken } = auth

  const {
    primaryInfo,
    showProfileModal,
    profileModalPage,
    notificationCount,
    emailVerificationStatus,
    advanceAccount,
    transportationMall,
  } = profile

  const { ticketCount } = watch

  return {
    accessToken,
    primaryInfo,
    showProfileModal,
    profileModalPage,
    notificationCount,
    transportationMall,
    emailVerificationStatus,
    ticketCount,
    advanceAccount,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setAccountStatus,
      displayProfileModal,
      setProfileModalPage,
      setNotificationCount,
      setEmailVerificationStatus,
      setTransportationMall,
      setTicketCount,
      setRedirectAfterAuth,
      setDisplayAppModal,
      push,
      waitRenderServer,
      renderServer,
    },
    dispatch,
  )

const ConnectedTransportationRoutes = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransportationRoutes)

export default ConnectedTransportationRoutes
